module.exports = __webpack_public_path__ + "static/media/datafiles_class.dfd36fb5.png";